import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { CasinoGamesPage } from 'src/domains/casino/components/games/CasinoGamesPage';
import { CategoriesPage } from 'src/components/CmsCasinoManagement/CategoriesPage';
import { TwoColumnResponsiveContentReverse } from 'src/domains/layouts/shared/layout/Layout.style';
import { LiveGamesState } from 'src/domains/casino/state/AppCasino/live-games/LiveGames.state';

interface CategoriesPagePropsType {
    liveGamesState: LiveGamesState;
}

export const CasinoContainer = observer('CasinoContainer', (props: CategoriesPagePropsType) => {
    return (
        <TwoColumnResponsiveContentReverse>
            <CategoriesPage liveGamesState={props.liveGamesState} />
            <CasinoGamesPage collection={props.liveGamesState.collection} />
        </TwoColumnResponsiveContentReverse>
    );
});
